/**
 * @module Utilities/Flux
 * @desc Flux helper funtions
 */

import type { ActionCreator, ActionPayload, GenericFunction } from './flux';

/**
 * Wraps an action creator so that its return value is the payload of a Flux Standard Action
 */
export function createAction<T extends GenericFunction>(
  type: string,
  payloadCreator: T,
): ActionCreator<Parameters<T>, ReturnType<T>> {
  if (!payloadCreator) {
    throw new TypeError('Expected a "payloadCreator" function');
  }

  return (...args: any[]): ActionPayload<ReturnType<T>> => ({
    type,
    payload: payloadCreator(...args),
  });
}
